/* eslint-disable react/prop-types */
/* eslint-disable react-refresh/only-export-components */
import { toast } from 'react-toastify';
import { Cross } from '../../assets/svgs/icons';
import i18n from '../../i18n';

const CustomToastComponent = ({ title, message, closeToast }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
    <p style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>{title}</p>
    <p
      style={{
        fontSize: 12,
        fontWeight: 400,
        flex: 1,
        margin: 0,
        // textAlign: 'center',
      }}
    >
      {message}
    </p>

    <div onClick={closeToast} style={{}}>
      <Cross color={'#fff'} width={14} height={14} />
    </div>
  </div>
);

const CustomToastComponent2 = ({ title, message, closeToast }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 18 }}>
    <div
      style={{
        marginLeft: 10,
      }}
    >
      <svg
        width="60"
        height="60"
        viewBox="0 0 76 69"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.4711 5.51233C32.7042 -1.82507 43.2941 -1.82508 47.5272 5.51233L74.4931 52.2532C78.7239 59.5865 73.4313 68.7501 64.965 68.7501H11.0333C2.56707 68.7501 -2.7255 59.5865 1.50526 52.2532L28.4711 5.51233ZM37.9999 24.7499C39.5187 24.7499 40.7499 25.9811 40.7499 27.4999V41.2499C40.7499 42.7687 39.5187 43.9999 37.9999 43.9999C36.4812 43.9999 35.2499 42.7687 35.2499 41.2499V27.4999C35.2499 25.9811 36.4812 24.7499 37.9999 24.7499ZM37.9999 54.9999C39.5187 54.9999 40.7499 53.7687 40.7499 52.2499C40.7499 50.7311 39.5187 49.4999 37.9999 49.4999C36.4812 49.4999 35.2499 50.7311 35.2499 52.2499C35.2499 53.7687 36.4812 54.9999 37.9999 54.9999Z"
          fill="#7A7E00"
        />
      </svg>
    </div>

    <div>
      <div>
        <p
          style={{
            fontSize: 16,
            fontWeight: 700,
            margin: 0,
            fontFamily: 'Poppins',
            color: '#4b4e00',
          }}
        >
          {title}
        </p>
      </div>

      <p
        style={{
          fontSize: 12,
          fontWeight: 400,
          fontFamily: 'Poppins',
          color: '#7A7E00',

          marginTop: 0,
        }}
      >
        {message}
      </p>
    </div>
  </div>
);

export const notifyErrorCustom = (message, title = 'Erro!', time = 8000, customStyle = {}) => {
  toast(<CustomToastComponent title={title} message={message} />, {
    style: {
      backgroundColor: '#FF2F00',
      color: '#fff',
      borderRadius: 10,
      ...customStyle,
    },
    closeButton: false,
    autoClose: time,
  });
};

export const notifySuccessCustom = (message, title) => {
  const resolvedTitle = title ?? i18n.t('notify_success_title');
  toast(<CustomToastComponent title={resolvedTitle} message={message} />, {
    style: {
      backgroundColor: '#3CBC00',
      color: '#fff',
      borderRadius: 10,
    },
    closeButton: false,
  });
};

export const notifyWarningCustom = (message, title = 'Aviso!') => {
  toast(<CustomToastComponent title={title} message={message} />, {
    style: {
      backgroundColor: '#f2f486',
      color: '#000000',
      borderRadius: 10,
    },
    closeButton: false,
  });
};
export const notifyWarningCustom2 = (message, title = 'Aviso!') => {
  toast(<CustomToastComponent2 title={title} message={message} />, {
    style: {
      backgroundColor: '#f2f486',
      color: '#000000',
      borderRadius: 10,
      width: '420px',
      right: 120,
    },
    closeButton: false,
  });
};
